import { ThemeSwitcher } from '@/shared/components/ThemeSwitcher'
import { NotificationCenter } from '@/shared/components/notifications'
import { authStore, logout } from '@/shared/store/auth.store'
import { useNavigate } from '@tanstack/react-router'
import { Button } from '@workspace/ui/components/Button'
import { UserAvatar } from '@workspace/ui/components/UserAvatar'
import { Menu, MenuItem, MenuPopover, MenuTrigger } from '@workspace/ui/components/Menu'
import { Separator } from '@workspace/ui/components/Separator'
import { useEffect, useState } from 'react'
import { LogOut, User } from 'lucide-react'
import { useSelector } from '@xstate/store/react'

export function HeaderActions() {
    const user = useSelector(authStore, state => state.context.user)
    const userPosition = user?.position || user?.role?.displayName || ''

    const navigate = useNavigate()
    const [displayAvatar, setDisplayAvatar] = useState(user?.avatar)

    // Fix flashing image fallback error when user.avatar update
    useEffect(() => {
        if (!user?.avatar) {
            setDisplayAvatar(null)
            return
        }
        const img = new Image()
        img.src = user.avatar
        img.onload = () => setDisplayAvatar(user.avatar)
        img.onerror = () => setDisplayAvatar(user.avatar)
    }, [user?.avatar])

    const handleProfile = () => {
        navigate({ to: '/profile' })
    }

    const handleSignOut = async () => {
        // Logout audit log is handled by backend
        await logout()
        navigate({ to: '/login' })
    }

    return (
        <div className="flex items-center gap-4">
            <ThemeSwitcher />

            {user && (
                <>
                    <NotificationCenter />
                    <Separator orientation="vertical" className="h-6" />
                    <MenuTrigger>
                        <Button variant="unstyled" className="flex items-center gap-2 p-0" aria-label="User menu">
                            <div className="text-right max-lg:hidden">
                                <div className="text-[14px] font-bold">{user.fullName}</div>
                                <div
                                    className="text-[12px] text-left whitespace-normal line-clamp-2 max-w-[200px]"
                                    title={userPosition}
                                >
                                    {userPosition}
                                </div>
                            </div>
                            <UserAvatar src={displayAvatar} alt={user.fullName} fallback={user.fullName} size="lg" />
                        </Button>
                        <MenuPopover placement="bottom end">
                            <Menu className="min-w-[200px]">
                                <MenuItem className="cursor-pointer" onAction={handleProfile}>
                                    <User className="size-4" />
                                    Thông tin cá nhân
                                </MenuItem>
                                <MenuItem className="cursor-pointer" onAction={handleSignOut}>
                                    <LogOut className="size-4" />
                                    Đăng xuất
                                </MenuItem>
                            </Menu>
                        </MenuPopover>
                    </MenuTrigger>
                </>
            )}
        </div>
    )
}
